/**
 * Licensed Materials - Property of IBM
 * IBM Cognos Products: Dashboard
 * (C) Copyright IBM Corp. 2019
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */
define([
	'../../../lib/@waca/dashboard-common/dist/core/APIFactory',
	'../../../lib/@waca/dashboard-common/dist/api/PropertiesProviderAPI',
	'../../../widgets/livewidget/nls/StringResources'
], function(APIFactory, PropertiesProviderAPI, StringResources) {

	const PROP_ID_SUPPRESSION = 'suppression';

	class SuppressionPropertyProvider {

		constructor(options) {
			this.content = options.content;
			// register self as a 'Properties' provider
			this.content && this.content.getFeature('Properties').registerProvider(this.getAPI());
		}

		getAPI() {
			if (!this._api) {
				this._api = APIFactory.createAPI(this, [PropertiesProviderAPI]);
			}
			return this._api;
		}

		destroy() {
			this.content = null;
		}

		getPropertyLayoutList() {
			return [];
		}

		getPropertyList() {
			const propertyList = [];
			if (this._isSupported()) {
				propertyList.push( {
					id: PROP_ID_SUPPRESSION,
					editor: {
						'sectionId': 'visualization.chart',
						uiControl: {
							type: 'ToggleButton',
							defaultValue: 'rowsAndColumns',
							label: StringResources.get(PROP_ID_SUPPRESSION),
							onChange: (propertyName, propertyValue) => {
								const overrideValue = propertyValue === false ? 'none' : 'rowsAndColumns';
								this.content.setPropertyValue(propertyName, overrideValue);
							}
						}
					},
					onPropertyChange: {
						refresh: {
							data: true
						}
					},
					defaultValue: 'rowsAndColumns'
				});
			}
			return propertyList;
		}

		reset() { }

		_isSupported() {
			const visApi = this.content.getFeature('Visualization');
			return (visApi && this._isSupportedVisType(visApi));
		}

		_isSupportedVisType(visApi) {
			return visApi.getType() === 'Crosstab' || visApi.getType() === 'List';
		}

		_isOlap(visApi) {
			const mappedSlot = visApi.getSlots().getMappedSlotList();
			const dataItem = mappedSlot[0] && mappedSlot[0].getDataItemList()[0];
			return dataItem && dataItem.getMetadataColumn().isOlapColumn() || false;
		}
	}

	return SuppressionPropertyProvider;
});
